import { isNotEmpty, isNotUndefined } from "../util/util";
import { makeAutoObservable } from "mobx";

class StateStore {
    _state = {};
    set state(value) {
        this._state = value;
    }
    get state() {
        return this._state;
    }

    constructor() {
        makeAutoObservable(this);
    }

    setState(id, value) {
        let state = this.state;
        if (Object.keys(state).length && isNotUndefined(state[id])) {
            state[id] = value;
            this._state = state;
        };
    };
    getState(name) {
        const keys = name.split('.');
        let value = Object.assign(this.state, {});
        for (let i = 0; i < keys.length; i++) {
            if (isNotEmpty(value[keys[i]])) {
                // 最終keyの場合
                if (keys.length === i + 1) break;

                // Dateオブジェクト以外のオブジェクトを参照する
                if (typeof value[keys[i]] === "Object") {
                    value = value[keys[i]] // 参照オブジェクト
                }
            }
        }
        return value[keys[keys.length - 1]];
    }
    addState(name, value) {
        this._state[name] = value;
    };
    clear() {
        this._state = {};
    }
}


const stateStore = new StateStore();

export default stateStore;
